import { PAGE_TYPE_CONFIRMATION } from 'shared/consts'
import {
  CONFIRMATION_PAGE_CSW,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { trackCswSlider } from 'shared/experiments/consts/trackCswSlider'
import { getExperiment } from 'shared/experiments/utils/experiments'
import store from 'shared/store'

export default () => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { experiments = [], pageType = '' } =
    publicRuntimeConfig?.pageProperties || {}
  const { variant, isEnabled } = getExperiment(
    CONFIRMATION_PAGE_CSW,
    experiments
  )
  if (!isEnabled || pageType !== PAGE_TYPE_CONFIRMATION) {
    return
  }

  if (variant === EXPERIMENT_VARIATION.V1) {
    trackCswSlider({})
  }
}
